<script lang="ts">
	import type { OperationModel } from '../../../models/api/OperationModel';
	import { t } from 'svelte-i18n';

	export let operation: OperationModel;
</script>

{#if operation.targetType !== 'FUNDS'}
	<div class="border-t border-grey-light py-4">
		<p>{$t('operation.proofOfVisibility', { values: { operationName: operation.name } })}</p>
	</div>
{/if}
